import React, { useState } from "react";
import logo from "../images/familee_tree_logo.svg";
import { useFormik } from "formik";
import { toast } from "react-toastify";
// import { Link } from "react-router-dom";
import { sendEmailOtp } from "../services/ApiServices";
import VerifyOtp from "./VerifyOtp";

const validate = (values) => {
  const errors = {};
  if (!values.emailId) {
    errors.emailId = "Please enter your email-ID.";
  } else if (
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.emailId)
  ) {
    errors.emailId = "Please enter a valid email address.";
  }
  return errors;
};
const ForgotPasswordEmailId = () => {
  const [verifyOTP, setVerifyOTP] = useState(false);
  const [emailID, setEmailID] = useState();
  const formik = useFormik({
    initialValues: { emailId: "" },
    validate,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        const sendOtpInfo = await sendEmailOtp(values);
        if (sendOtpInfo.status === 200) {
          toast.success(sendOtpInfo?.data?.message);
          setEmailID(values?.emailId);
          setVerifyOTP(true);
          return;
        }
      } catch (error) {
        console.error("send Otp Info error:", error);
        toast.error(error.response.data.message);
      } finally {
        setSubmitting(false);
      }
    },
  });
  return !verifyOTP ? (
    <React.Fragment>
      <div className="login-page">
        <div className="login-container">
          <img src={logo} alt="FamileeTree" className="logo" />
          <form className="login-form" onSubmit={formik.handleSubmit}>
            <div className="input-group">
              <label htmlFor="emailId">Enter your email address</label>
              <input
                type="text"
                id="emailId"
                name="emailId"
                value={formik.values.emailId}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
            {formik.touched.emailId && formik.errors.emailId ? (
              <p className="error-message">{formik.errors.emailId}</p>
            ) : null}
            <button type="submit">Send OTP</button>
          </form>
          {/* <br/>
              <p>Or</p>
              <div >
              Forgot password using<Link to='/forgetPasswordMobile'><span className="login-forget"> Mobile Number?</span></Link>
              </div>
              */}
        </div>
      </div>
    </React.Fragment>
  ) : (
    <VerifyOtp emailId={emailID} />
  );
};
export default ForgotPasswordEmailId;
